import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Invoice from '@spike/invoice-model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import InvoiceResumeTaxes from './InvoiceResumeTaxes';
import ResumeLine from './UI/ResumeLine';
import TotalResumeTotal from './UI/TotalResumeLine';
import { formatAmount } from './utils/OrderUtils';

export interface InvoiceResumeProps {
    invoice?: Invoice;
    loadingInvoice?: boolean;
    loadingTip?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        lineTopMargin: {
            marginTop: 11
        },
        balanceContainer: {
            display: 'flex',
            flexDirection: 'column',
            borderTop: '1px solid #D4D4D4',
            paddingTop: 15,
            marginTop: 15
        }
    })
);

export const InvoiceResume: FunctionComponent<InvoiceResumeProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <ResumeLine
                description="Subtotal"
                value={formatAmount(props.invoice?.subtotal)}
                loading={props.loadingInvoice}
            />
            {/*<ResumeLine
                description="Discount"
                amount='$0.00'
                icon={faTrashAlt}
                className={classes.lineTopMargin}
            />*/}
            <InvoiceResumeTaxes
                taxes={props.invoice?.tax}
                loading={props.loadingInvoice}
                className={classes.lineTopMargin}
            />
            {Number(props.invoice?.tip?.amount ?? 0) > 0 && (
                <ResumeLine
                    description="Tip"
                    value={formatAmount(props.invoice?.tip?.amount)}
                    loading={props.loadingInvoice || props.loadingTip}
                    className={classes.lineTopMargin}
                />
            )}
            <TotalResumeTotal
                description="Total"
                value={formatAmount(props.invoice?.grandTotal)}
                loading={props.loadingInvoice || props.loadingTip}
                className={classes.lineTopMargin}
            />
            <ResumeLine
                description="Deposit"
                value={formatAmount(`-${props.invoice?.deposits.total}`)}
                loading={props.loadingInvoice}
                className={classes.lineTopMargin}
            />
            {Number(props.invoice?.payments.totalWithoutDeposits) > 0 && (
                <ResumeLine
                    description="Payments"
                    value={formatAmount(`-${props.invoice?.payments.totalWithoutDeposits}`)}
                    loading={props.loadingInvoice || props.loadingTip}
                    className={classes.lineTopMargin}
                />
            )}
            <Box className={classes.balanceContainer}>
                <TotalResumeTotal
                    description="Balance Due"
                    value={formatAmount(props.invoice?.balance)}
                    loading={props.loadingInvoice || props.loadingTip}
                />
            </Box>
        </Box>
    );
};

export default InvoiceResume;
